
import React, { createContext, useContext, useState, useEffect } from 'react';
import { muiDarkTheme, muiLightTheme } from './muiTheme';


const ThemeContext = createContext();
export const useAppTheme = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }) => {

  // Initialize theme from localStorage. Defaults to 'dark'
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
  };


  const muiTheme = theme === 'dark' ? muiDarkTheme : muiLightTheme;


  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, muiTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
